












import { Component, Vue, Prop } from "vue-property-decorator";
import Button from "./Button.vue";
@Component({
  name: "switchlanguage",
  components: {
    Button
  }
})
export default class SwitchLanguage extends Vue {
  @Prop() value;

  toBn() {
    this.$emit("input", "bn");
  }

  toEn() {
    this.$emit("input", "en");
  }
}
